import MainLayout from 'components/layout/MainLayout';
import BlogArticle from 'components/blog/BlogArticle';
import { ASSET_PREFIX } from 'utils/constants';
import { NextSeo } from "next-seo";

const InnerInfluencerArticle = () => {
  const IMAGE_DIRECTORY = `${ASSET_PREFIX}/images/blog/articles/inner-influencer`;

  return (
    <MainLayout>
      <NextSeo
        title='6 Places Around The World To Embrace Your Inner Influencer | DAYMADE'
        description='Read more about the most instagrammable places in the world. Become an influencer simply by visiting these beautiful destinations and living your #bestlife.'
        openGraph={{
          title: '6 Places Around The World To Embrace Your Inner Influencer | DAYMADE',
          description: 'Read more about the most instagrammable places in the world. Become an influencer simply by visiting these beautiful destinations and living your #bestlife.',
          type: 'article',
          url: 'https://www.daymade.co.uk/blog/6-places-around-the-world-to-embrace-your-inner-influencer',
          images: [{
            url: `${IMAGE_DIRECTORY}/hero.jpg`,
            alt: 'woman, holding hand of person, leading up old street hill with pastel salmon coloured houses on either side'
          }]
        }}
        // additionalMetaTags={[{
        //   name: 'keywords',
        //   content: 'influncer,trips,tricks,explorer,instagram,instagrammable,festival,hawaii,bali,awareness,competition,gifts,beach,indonesia,fiji,mexico,italy,travel,destinations'
        // }]}
      />

      <BlogArticle
        imageDirectory={IMAGE_DIRECTORY}
        heroAltText='woman, holding hand of person, leading up old street hill with pastel salmon coloured houses on either side'
      >
        <>
          <h1 style={{ fontSize: '1.6em' }}>
            6 Places Around <strong>The World</strong>
          </h1>

          <p className='subheading'>
            to embrace your inner influencer
          </p>

          <div className='separator' style={{ width: '80%', marginTop: 0 }} />

          <p>
            <span className='bigFirstLetter'>Y</span>ou’ve got everything it takes to be an influencer – except maybe the few hundred thousand followers on Instagram. You know how to place your coffee just right, so the sunshine perfectly hits the foam on the heart the barista crafted in your cup. Golden Hour is your Happy Hour and credit is long overdue for your spin on the beach sunset motif? Then you’re already living an influencer kind of life!
          </p>

          <p>
            DAYMADE has got you covered when it comes to travel destinations to let your inner influencer live its best life at some of the most beautiful places on earth.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary1.jpg`}
            alt='girl with silver face paint and dress smiling at a sunny festival'
            className='singleBlogImage'
          />

          <h4>
            HAWAII, <strong>USA</strong>
          </h4>

          <p>
            Hawaii is on every influencer’s bucket list! Or at least it should be. A sun-kissed chainof gorgeous islands, Hawaii is one of the most sought-after destinations for surfers, health-conscious visitors, nature lovers and celebrities alike.
          </p>

          <p>
            Deep blue waters, white sandy beaches, tropical rainforests, emerald green landscapes –everything is picturesque on this secluded paradise in the Pacific. As one of the most remote groups of islands in the world, who wouldn’t be curious to hear more about your exclusive experience on the Aloha isles?
          </p>

          <h4>
            IBIZA, <strong>SPAIN</strong>
          </h4>

          <p>
            The Balearic Islands’ most popular destination is home to loads of top-notch spots to live your best life. Best known for its party scene, Ibiza is also a haven to celebrities, yogis, health retreats, hillside hamlets, picturesque beaches and loads of great places to take selfies for your future as an influencer.
          </p>

          <h4>
            BALI, <strong>INDONESIA</strong>
          </h4>

          <p>
            Bali is a magical destination to give into your wanderlust and travel the world like a true influencer.
          </p>

          <p>
            Yoga, raw vegan everything, waves, great internet connection – the island is truly what influencer dreams are made of.
          </p>

          <div className='doubleImageContainer'>
            <img
              src={`${IMAGE_DIRECTORY}/secondary2.jpg`}
              alt='woman in swimsuit overlooking misty sunset from rocky beach with blue water'
              className='doubleBlogImage'
            />

            <img
              src={`${IMAGE_DIRECTORY}/secondary3.jpg`}
              alt='smiling girl with sunglasses against pastel orange wall in sunny place with palm trees in distance'
              className='doubleBlogImage'
            />
          </div>

          <h4>
            FIJI
          </h4>

          <p>
            When you’re living your best influencer life, amazing experiences and the accompanying photos are a must. That’s why you want the colours to absolutely pop in those snap-worthy moments.
          </p>

          <p>
            The waters around Fiji aren’t just great for swimming, they’re also perfect for boat trips! Hop on board a sailboat or yacht and soak up some rays as you lounge on the sun deck. Sunset on the water is the perfect sundowner.
          </p>

          <h4>
            TULUM, <strong>MEXICO</strong>
          </h4>

          <p>
            What happens in Tulum, stays in Tulum. But obviously you have to share it with the 3Fs – your closest family, friends and fans! Stunning azure waters provide the perfect backdrop for showcasing your latest adventures to the world.
          </p>

          <p>
            Lazing by the beach all day while planning your next influencer-esque move is what Tulum is all about.
          </p>

          <h4>
            TUSCANY, <strong>ITALY</strong>
          </h4>

          <p>
            Tuscany’s rolling green hills offer plenty of inspiration for exhilarating adventures – and beautiful moments to capture on film. As home to one of the most popular destinations for the Italian countryside experience, every opportunity is the perfect chance to turn your swoon-worthy European adventures into frameable wall art – or posts.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary4.jpg`}
            alt='influencer couple overlooking beach from grassy hilltop'
            className='singleBlogImage'
          />

          <p>
            The life of an influencer is not easy, but somebody’s got to do it. So, it might as well be you! And if you’re still not quite there yet, at least you can always travel like an influencer with DAYMADE’ travel tips.
          </p>
        </>
      </BlogArticle>
    </MainLayout>
  );
};

export default InnerInfluencerArticle;
